<template>
  <div style="display: inline-block">
    <a-button size="small" @click="editVisit">{{ $t("edit") }}</a-button>
    <a-modal  style="top: 20px"
              v-model:visible="visible"
              :title="$t('edit')"
              @ok="handleOk"
              :okText="$t('submit')"
              :cancelText="$t('cancel')"
    >
      <a-form
          ref="proteinForm"
          :model="visit"
          :rules="rules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
      >
        <a-form-item ref="username" :label="$t('user.name')" name="username">
          <a-input v-model:value="visit.user.name" :disabled="true" placeholder="必填"/>
        </a-form-item>
        <a-form-item ref="group" :label="$t('user.group')" name="group">
          <a-input v-model:value="visit.user.group.groupname" :disabled="true" placeholder="必填"/>
        </a-form-item>
        <a-form-item ref="phone" :label="$t('phone')" name="phone">
          <a-input v-model:value="visit.phone" placeholder="必填"/>
        </a-form-item>
        <a-form-item ref="usertype" :label="$t('user.usertype')" name="usertype">
          <a-select v-model:value="visit.usertype" mode="multiple">
            <a-select-option value="00">{{ $t("user.normalUser") }}</a-select-option>
            <a-select-option value="01">{{ $t("user.labAdmin") }}</a-select-option>
            <a-select-option value="02">{{ $t("user.PI") }}</a-select-option>
            <a-select-option value="99">{{ $t("user.adminUser") }}</a-select-option>
          </a-select>
        </a-form-item>
<!--        <a-form-item ref="status" :label="$t('status')" name="status">-->
<!--          <a-select v-model:value="visit.status">-->
<!--            <a-select-option value="01">{{ $t("user.normal") }}</a-select-option>-->
<!--            <a-select-option value="09">{{ $t("user.band") }}</a-select-option>-->
<!--          </a-select>-->
<!--        </a-form-item>-->
<!--        <a-form-item ref="starttime" :label="$t('user.banStart')" name="starttime">-->
<!--          <a-date-picker-->
<!--              v-model:value="visit.starttime"-->
<!--              style="width: 100%"-->
<!--          />-->
<!--        </a-form-item>-->
<!--        <a-form-item ref="endtime" :label="$t('user.banEnd')" name="endtime">-->
<!--          <a-date-picker-->
<!--              v-model:value="visit.endtime"-->
<!--              style="width: 100%"-->
<!--          />-->
<!--        </a-form-item>-->
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import util from "@/util/util";

export default {
  name: "editVisit",
  props : {
    visitId : String,
  },
  data(){
    return{
      visible : false,
      loading : false,
      visit : {
        user : {
          group:{}
        }
      },
      rules : {}
    }
  },
  methods : {
    handleOk(){
      // if (this.visit.status === "09"){
      //   if (util.isNull(this.visit.starttime)){
      //     this.$message.error(this.$t("pleaseSelect") + this.$t("user.banStart"));
      //     return;
      //   }
      //   if (util.isNull(this.visit.endtime)){
      //     this.$message.error(this.$t("pleaseSelect") + this.$t("user.banEnd"));
      //     return;
      //   }
      // }
      var post = {
        visit : JSON.stringify(this.visit)
      }
      var that = this;
      util.$post("/admin/userManage/editUser/submit", post, function (){
        util.submitSuccess();
        that.$emit("change");
        that.visible = false;
      }, this.loadingShow, this.loadingHide)
    },
    initPage(){
      var post = {
        visitId : this.visitId
      }
      var that = this;
      util.$post("/admin/userManage/editUser/init", post,  (res)=>{
        that.visit = res.visit;
        this.visit.usertype = JSON.parse(this.visit.usertype)
      }, this.loadingShow, this.loadingHide)
    },
    loadingShow() {
      this.loading = true;
    },
    loadingHide() {
      this.loading = false;
    },
    editVisit(){
      this.visible = true;
      this.initPage();
    },
  }
}
</script>

<style scoped>

</style>